import { PickingPoint } from "@core/entities";
import { AdapterUi } from "@core/store/adapters/global.adapter";
import { createAction, props } from "@ngrx/store";
import { IncompleteStores } from "../../entities/picking-points.entities";

export enum PickingPointAction {
  ClearAll = "[PICKING-POINTS] Clear all picking-points",
  UiPickingPoints = "[PICKING-POINTS] UI picking-points",
  Empty = "[PICKING-POINTS] Empty",
  FetchPickingPoints = "[PICKING-POINTS] Fetch Picking points",
  SetPickingPoints = "[PICKING-POINTS] Set Picking points",
  UpdatePickingPointStatus = "[PICKING-POINTS] Update Picking Point",
  FetchPickingPointId = "[PICKING-POINTS] Fetch Picking point by Id",
  DeletePickingPoint = "[PICKING-POINTS] Delete PP",
  DeletePickingPointRequest = "[PICKING-POINTS] Delete PP Request",
  GetCoreStores = "[PICKING-POINTS] Get Core Stores",
  AppendCoreStores = "[PICKING-POINTS] Append Core Stores",
  ImportSelectedStores = "[PICKING-POINTS] Import Selected Stores",
  SetIncompleteStores = "[PICKING-POINTS] Set Incomplete Stores",
  FilterIncompleteStores = "[PICKING-POINTS] Filter Incomplete Stores",
  UpdateIncompletePickingPoints = "[PICKING-POINTS] Update Incomplete PickingPoints",
}

export const clearAll = createAction(PickingPointAction.ClearAll);
export const uiPickingPoints = createAction(PickingPointAction.UiPickingPoints, props<{ ui: Array<AdapterUi> }>());
export const Empty = createAction(PickingPointAction.Empty);

export const updateIncompletePickingPoints = createAction(PickingPointAction.UpdateIncompletePickingPoints, props<{ payload: PickingPoint[] }>());
export const updatePickingPointStatus = createAction(PickingPointAction.UpdatePickingPointStatus, props<{ payload: Partial<PickingPoint> }>());
export const fetchPickingPoints = createAction(PickingPointAction.FetchPickingPoints, props<{search?: string}>());
export const setPickingPoints = createAction(PickingPointAction.SetPickingPoints, props<{ payload: PickingPoint[] }>());
export const deletePickingPoint = createAction(PickingPointAction.DeletePickingPoint, props<{ id: number }>());
export const deletePickingPointRequest = createAction(PickingPointAction.DeletePickingPointRequest, props<{ id: number }>());
export const getCoreStores = createAction(PickingPointAction.GetCoreStores, props<{ page: number, storeId: number }>());
export const appendCoreStores = createAction(PickingPointAction.AppendCoreStores, props<{ stores: any[] }>());
export const importSelectedStores = createAction(PickingPointAction.ImportSelectedStores, props<{ stores: any[] }>());
export const setIncompleteStores = createAction(PickingPointAction.SetIncompleteStores, props<{ stores: IncompleteStores }>());
export const filterIncompleteStores = createAction(PickingPointAction.FilterIncompleteStores, props<{ stores: Array<{data: Partial<PickingPoint>, validationError?: string}> }>());
